export default __webpack_public_path__ + "static/media/1556.f06ed56b.png";